import React, { useState } from "react";

import { connect } from "react-redux";
import { seturlcamicia } from "../../state/actions";

import { euro } from "../helpers";
import { prices, owner } from "../../data";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

import {
  navColletti,
  navPolsini,
  navChiusure,
  navTaschini,
  navPinces,
  navBottoni,
  navAsole,
  navFili,
  navFondo,
  navVesti,
  navManiche,
  navContrasti,
} from "../navigazione/navigazione.js";

const BloccoAcquisto = (props) => {
  const [state, setState] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "right",
  });

  const { vertical, horizontal, open } = state;

  const snackClick = (newState) => () => {
    setState({ open: true, ...newState });
  };

  const snackClose = () => {
    setState({ ...state, open: false });
  };

  const [qty, setQty] = useState(1);

  const { lingua, data, camicia, setUrlCamicia } = props;

  const { misure, iniziali } = camicia;

  const infoColletti = navColletti[camicia.colletto][`nome_${lingua.lang}`];
  const infoPolsini = navPolsini[camicia.polsino][`nome_${lingua.lang}`];
  const infoChiusure = navChiusure[camicia.chiusura][`nome_${lingua.lang}`];
  const infoTaschini = navTaschini[camicia.taschino][`nome_${lingua.lang}`];
  const infoPinces = navPinces[camicia.pince][`nome_${lingua.lang}`];
  const infoBottoni = navBottoni[camicia.bottone][`nome_${lingua.lang}`];
  const infoAsole = navAsole[camicia.asola + 1][`nome_${lingua.lang}`];
  const infoFili = navFili[camicia.filo + 1][`nome_${lingua.lang}`];
  const infoFondo = navFondo[camicia.fondo][`nome_${lingua.lang}`];
  const infoManiche = navManiche[camicia.manica][`nome_${lingua.lang}`];
  const infoClubColletto = camicia.clubColletto ? " Club colletto" : ", ";
  const infoClubPolsino = camicia.clubPolsino ? "Club polsino" : "";
  const infoRicambio = camicia.ricambio ? "Colletto e polsino di ricambio" : "";

  let infoContrasti = "";
  let infoContrastoTessuto = "";
  if (camicia.contrasto > 0) {
    infoContrasti =
      lingua.navigazione.contrasto + " " + lingua.navigazione.tessuto + " ";
    infoContrastoTessuto =
      navContrasti[camicia.contrasto][`nome_${lingua.lang}`];
  }
  const infoContrastiFinale =
    infoContrasti +
    infoContrastoTessuto ;
  let infoDivid = infoContrastiFinale !== "" ? ", " : " ";

  const infoCustom =
    lingua.navigazione.colletto +
    ": " +
    infoColletti +
    ", " +
    lingua.navigazione.polsino +
    ": " +
    infoPolsini +
    ", " +
    infoRicambio +
    ", " +
    lingua.navigazione.chiusura +
    ": " +
    infoChiusure +
    ", " +
    lingua.navigazione.taschino +
    ": " +
    infoTaschini +
    ", " +
    lingua.navigazione.pinces +
    ": " +
    infoPinces +
    ", " +
    lingua.navigazione.bottoni +
    ": " +
    infoBottoni +
    ", " +
    lingua.navigazione.asole +
    ": " +
    infoAsole +
    ", " +
    lingua.navigazione.fili +
    ": " +
    infoFili +
    ", " +
    lingua.navigazione.fondo +
    ": " +
    infoFondo +
    ", " +
    lingua.navigazione.manica +
    ": " +
    infoManiche +
    ", " +
    infoDivid +
    infoContrastiFinale +
    "Club:" +
    infoClubColletto +
    " " +
    infoClubPolsino

  let infoMisure = "";
  switch (misure.tipo) {
    case 0:
      infoMisure =
        lingua.navigazione.misure.infoTipoMisure +
        " " +
        lingua.navigazione.misure.infoTipoMisure0 +
        " (" +
        lingua.navigazione.misure.infoTagliaSelezionata +
        " " +
        misure.taglia +
        "). " +
        lingua.navigazione.misure.infoVestibilita +
        ": " +
        misure.fit +
        ".";
      break;
    case 1:
      infoMisure =
        lingua.navigazione.misure.infoTipoMisure +
        " " +
        lingua.navigazione.misure.infoTipoMisure1 +
        ". " +
        lingua.navigazione.misure.Braccia +
        ": " +
        misure.braccia +
        " cm; " +
        lingua.navigazione.misure.Collo +
        ": " +
        misure.collo +
        " cm; " +
        lingua.navigazione.misure.Girovita +
        ": " +
        misure.girovita +
        " cm; " +
        lingua.navigazione.misure.Lunghezza +
        ": " +
        misure.lunghezza +
        " cm; " +
        lingua.navigazione.misure.Polso +
        ": " +
        misure.polso +
        " cm; " +
        lingua.navigazione.misure.Spalle +
        ": " +
        misure.spalle +
        " cm; " +
        lingua.navigazione.misure.Torace +
        ": " +
        misure.torace +
        " cm; " +
        lingua.navigazione.misure.infoVestibilita +
        ": " +
        misure.fit +
        ".";
      break;
    case 2:
      infoMisure =
        lingua.navigazione.misure.infoTipoMisure +
        " " +
        lingua.navigazione.misure.infoTipoMisure2 +
        ". " +
        lingua.navigazione.misure.Braccia +
        ": " +
        misure.braccia +
        " cm; " +
        lingua.navigazione.misure.Collo +
        ": " +
        misure.collo +
        " cm; " +
        lingua.navigazione.misure.Girovita +
        ": " +
        misure.girovita +
        " cm; " +
        lingua.navigazione.misure.Lunghezza +
        ": " +
        misure.lunghezza +
        " cm; " +
        lingua.navigazione.misure.Polso +
        ": " +
        misure.polso +
        " cm; " +
        lingua.navigazione.misure.Spalle +
        ": " +
        misure.spalle +
        " cm; " +
        lingua.navigazione.misure.Torace +
        ": " +
        misure.torace +
        " cm.";
      break;
    case 3:
      infoMisure =
        lingua.navigazione.misure.infoTipoMisure +
        " " +
        lingua.navigazione.misure.infoTipoMisure3 +
        ".";
      break;
    default:
      infoMisure = "";
  }

  let iniColore = lingua.navigazione.iniziali.bianco;
  switch (iniziali.colore) {
    case 0:
      iniColore = lingua.navigazione.iniziali.bianco;
      break;
    case 1:
      iniColore = lingua.navigazione.iniziali.blu;
      break;
    case 2:
      iniColore = lingua.navigazione.iniziali.celeste;
      break;
    case 3:
      iniColore = lingua.navigazione.iniziali.rosso;
      break;
    case 4:
      iniColore = lingua.navigazione.iniziali.nero;
      break;
    case 5:
      iniColore = lingua.navigazione.iniziali.grigio;
      break;
    case 6:
      iniColore = lingua.navigazione.iniziali.arancione;
      break;
    case 7:
      iniColore = lingua.navigazione.iniziali.verde;
      break;
    case 8:
      iniColore = lingua.navigazione.iniziali.rosa;
      break;
    default:
      iniColore = lingua.navigazione.iniziali.bianco;
  }

  let iniPosizione = lingua.navigazione.iniziali.sopra;
  switch (iniziali.posizione) {
    case 0:
      iniPosizione = lingua.navigazione.iniziali.sopra;
      break;
    case 1:
      iniPosizione = lingua.navigazione.iniziali.centro;
      break;
    case 2:
      iniPosizione = lingua.navigazione.iniziali.sotto;
      break;
    default:
      iniPosizione = lingua.navigazione.iniziali.sopra;
  }

  let infoIniziali = "";
  if (iniziali.testo !== "") {
    infoIniziali =
      " --- " +
      lingua.navigazione.iniziali.iniziali +
      ": '" +
      iniziali.testo +
      "', " +
      lingua.navigazione.iniziali.stile1 +
      ": " +
      iniziali.stile +
      ", " +
      lingua.navigazione.iniziali.colore1 +
      ": " +
      iniColore +
      ", " +
      lingua.navigazione.iniziali.posizione1 +
      ": " +
      iniPosizione +
      ".";
  }

  const ordine =
    data.nome +
    " " +
    data.codice +
    " " +
    data.brand +
    " --- " +
    data[`descrizione_${lingua.lang}`] +
    " --- " +
    infoCustom +
    " --- " +
    infoMisure +
    infoIniziali;


  
  let prezzoColletto = 0;
  let prezzoPolsino = 0;
  if (camicia.contrasto > 0) {
    prezzoColletto = camicia.contrastoColletto ? prices.contrastoColletto : 0;
    prezzoPolsino = camicia.contrastoPolsino ? prices.contrastoPolsino : 0;
    
  }

  const prezzoRicambio = camicia.ricambio ? prices.ricambio : 0
  const prezzoBottoni = camicia.bottone > 13 ? prices.madreperla : 0
  const prezzoClubColletto = camicia.clubColletto ? prices.clubColletto : 0;
  const prezzoClubPolsino = camicia.clubPolsino ? prices.clubPolsino : 0;
  const prezzoIniziali =   iniziali.testo !== "" ? prices.iniziali : 0;
  const prezzoTotale =
    (data.prezzo +
      prezzoIniziali +
      prezzoBottoni +
      prezzoRicambio +
      prezzoColletto +
      prezzoPolsino +
      prezzoClubColletto +
      prezzoClubPolsino) *
    qty;

  return (
    <>
      <div className="columns is-mobile is-hidden-desktop is-vcentered" >
        
        <div className="column is-narrow">
          <p className="is-size-4 has-text-weight-semibold">
            {data.prezzo < data.prezzo_old && (
              <s
                className="is-size-5"
                style={{ marginRight: "1rem", opacity: "0.5" }}
              >
                {euro(data.prezzo_old)}
              </s>
            )}
            {euro(prezzoTotale)}
          </p>
        </div>
        <div className="column">
          <button
            className="button is-dark is-radiusless is-fullwidth snipcart-add-item"
            data-item-id={data.codice}
            data-item-price={prezzoTotale}
            data-item-url={owner.appUrl + "/camicia/" + data.Path + "/"}
            data-item-description={ordine}
            data-item-image={
              data.immagine.localFiles[0].childImageSharp.gatsbyImageData.src
            }
            data-item-name={lingua.barraAcquisto.camicia + " " + data.nome}
            data-item-weight={450}
            data-item-quantity={qty}
            data-item-max-quantity={10}
            data-item-min-quantity={1}
            data-item-stackable={"never"}
            onClick={
              (() => setUrlCamicia(0),
              snackClick({
                vertical: "bottom",
                horizontal: "right",
              }))
            }
          >
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {lingua.barraAcquisto.carrello}
            </span>
          </button>
        </div>
      </div>

      <div className="is-hidden-touch">
        <p className="is-size-4 has-text-weight-semibold mb-3">
          {data.prezzo < data.prezzo_old && (
            <s
              className="is-size-5"
              style={{ marginRight: "1rem", opacity: "0.5" }}
            >
              {euro(data.prezzo_old)}
            </s>
          )}
          {euro(prezzoTotale)}
        </p>

        <div className="field has-addons">
          <p className="control">
            <button
              onClick={() => setQty(qty > 1 ? qty - 1 : qty)}
              className="button is-radiusless is-light"
            >
              <RemoveIcon />
            </button>
          </p>
          <p className="control">
            <input
              type="text"
              disabled
              value={qty}
              className="input is-radiusless is-light"
              style={{ width: "3rem", textAlign: "center", border: "none" }}
            />
          </p>
          <p className="control">
            <button
              onClick={() => setQty(qty < 10 ? qty + 1 : qty)}
              className="button is-radiusless is-light"
            >
              <AddIcon />
            </button>
          </p>
        </div>

        <button
          className="button is-dark is-radiusless is-fullwidth snipcart-add-item"
          data-item-id={data.codice}
          data-item-price={prezzoTotale}
          data-item-url={owner.appUrl + "/camicia/" + data.Path + "/"}
          data-item-description={ordine}
          data-item-image={
            data.immagine.localFiles[0].childImageSharp.gatsbyImageData.src
          }
          data-item-name={lingua.barraAcquisto.camicia + " " + data.nome}
          data-item-weight={450}
          data-item-quantity={qty}
          data-item-max-quantity={10}
          data-item-min-quantity={1}
          data-item-stackable={"never"}
          onClick={
            (() => setUrlCamicia(0),
            snackClick({
              vertical: "bottom",
              horizontal: "right",
            }))
          }
        >
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {lingua.barraAcquisto.carrello}
          </span>
        </button>
      </div>

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={snackClose}
        autoHideDuration={3000}
        key={vertical + horizontal}
      >
        <div className="notification is-success" onClick={snackClose}>
          <button className="delete" />
          Prodotto aggiunto al carrello
        </div>
      </Snackbar>
    </>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    setUrlCamicia: (val) => dispatch(seturlcamicia(val)),
  };
}

export default connect(null, mapDispatchToProps)(BloccoAcquisto);
